module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/assign-subscription/assign-subscription.component.scss
// module id = ./src/app/admin/assign-subscription/assign-subscription.component.scss
// module chunks = main